export const brandName = '搞鸡动画';

export const navLinks = [
  { id: 'home', label: '首页' },
  { id: 'analysis', label: '剧情解析' },
  { id: 'scenes', label: '名场面' },
  { id: 'characters', label: '角色关系' },
  { id: 'clips', label: '高能剪辑' },
  { id: 'episodes', label: '分集解说' },
  { id: 'faq', label: '常见问题' },
];

export const heroStats = [
  { value: '12', label: '集分集解说' },
  { value: '36', label: '篇剧情解析' },
  { value: '58', label: '高能片段' },
  { value: '20w+', label: '累计追更' },
];

export type Article = {
  id: string;
  tag: string;
  title: string;
  excerpt: string;
  readTime: string;
  date: string;
  image: string;
};

export const plotArticles: Article[] = [
  {
    id: 'foreshadow',
    tag: '深度解析',
    title: '第一季伏笔全梳理：鸡哥的眼神早就埋好了所有答案',
    excerpt:
      '从第一集到第十二集，镜头里那些一闪而过的细节其实都在暗示结局。我们把鸡哥每次望向远处的眼神、大姨食堂门口的铁锅、豆包反复念叨的口头禅全部连成一条线。',
    readTime: '8分钟',
    date: '08-15',
    image:
      'https://readdy.ai/api/search-image?query=stylized%202d%20cartoon%20scene%20of%20a%20thoughtful%20rooster%20character%20looking%20into%20the%20distance%20with%20warm%20sunset%20glow%2C%20clues%20and%20handwritten%20notes%20floating%20around%20him%2C%20warm%20coral%20and%20cream%20palette%2C%20bold%20flat%20vector%20illustration%2C%20playful%20comic%20style%2C%20clean%20background&width=800&height=600&seq=plot-1&orientation=landscape',
  },
  {
    id: 'canteen',
    tag: '隐喻解读',
    title: '《大姨食堂》这一回：藏在一碗热汤里的真正暗线',
    excerpt:
      '为什么大姨总是把最后一块红烧肉留给鸡哥？为什么每次关键抉择都发生在食堂？大姨的勺子不只是做饭的工具，更是全剧最重要的象征物。',
    readTime: '6分钟',
    date: '08-13',
    image:
      'https://readdy.ai/api/search-image?query=cozy%20stylized%202d%20cartoon%20canteen%20kitchen%20with%20a%20warm%20steaming%20wok%20of%20soup%20and%20bright%20vegetables%2C%20a%20ladle%20in%20the%20foreground%2C%20warm%20amber%20and%20cream%20palette%2C%20flat%20vector%20illustration%2C%20friendly%20comic%20aesthetic%2C%20clean%20background&width=800&height=600&seq=plot-2&orientation=landscape',
  },
  {
    id: 'ending',
    tag: '结局解读',
    title: '结局的真正含义：为什么鸡哥最后选择了独自离开',
    excerpt:
      '有人说这是遗憾，有人说这是成长。我们翻遍十二集的细节，发现鸡哥的选择早有铺垫——他一直在等一个没人知道的答案。结尾独白的每一句都值得反复咀嚼。',
    readTime: '9分钟',
    date: '08-10',
    image:
      'https://readdy.ai/api/search-image?query=emotional%20stylized%202d%20cartoon%20scene%20of%20a%20rooster%20character%20walking%20away%20alone%20on%20a%20country%20road%20at%20golden%20dusk%2C%20friends%20watching%20from%20behind%20silhouette%2C%20warm%20coral%20and%20peach%20palette%2C%20flat%20vector%20illustration%2C%20cinematic%20comic%20composition%2C%20clean%20background&width=800&height=600&seq=plot-3&orientation=landscape',
  },
];

export type Scene = {
  rank: string;
  episode: string;
  title: string;
  desc: string;
  image: string;
};

export const famousScenes: Scene[] = [
  {
    rank: '01',
    episode: '第9集',
    title: '屋顶对峙',
    desc: '阿绿终于摊牌，一句“我等的从来不是输赢”把全场情绪推到顶点。分镜、配乐、台词节奏都堪称教科书。',
    image:
      'https://readdy.ai/api/search-image?query=dramatic%20stylized%202d%20cartoon%20showdown%20of%20two%20animal%20characters%20facing%20each%20other%20on%20a%20rooftop%20at%20dusk%2C%20warm%20orange%20sky%2C%20strong%20silhouettes%2C%20flat%20vector%20illustration%2C%20tense%20comic%20energy%2C%20clean%20background&width=800&height=600&seq=scene-1&orientation=landscape',
  },
  {
    rank: '02',
    episode: '第7集',
    title: '雨夜道歉',
    desc: '豆包哭着把藏了一整集的鸡腿还回来，一句“对不起，但我是为了你好”让弹幕集体破防。',
    image:
      'https://readdy.ai/api/search-image?query=rainy%20night%20stylized%202d%20cartoon%20scene%20of%20a%20small%20round%20dog%20character%20holding%20out%20a%20drumstick%20in%20the%20rain%2C%20warm%20lamplight%2C%20touching%20emotional%20moment%2C%20flat%20vector%20illustration%2C%20blue%20free%20warm%20palette%2C%20clean%20background&width=800&height=600&seq=scene-2&orientation=landscape',
  },
  {
    rank: '03',
    episode: '第5集',
    title: '食堂大战',
    desc: '大姨一勺定乾坤，全场噤声。看似是抢菜，其实是全剧第一次“以暴制爱”的高光时刻。',
    image:
      'https://readdy.ai/api/search-image?query=action%20stylized%202d%20cartoon%20scene%20of%20a%20chef%20character%20slamming%20a%20big%20ladle%20on%20a%20table%20in%20a%20canteen%2C%20food%20flying%2C%20comic%20speed%20lines%2C%20warm%20amber%20and%20cream%20palette%2C%20flat%20vector%20illustration%2C%20playful%20energy%2C%20clean%20background&width=800&height=600&seq=scene-3&orientation=landscape',
  },
  {
    rank: '04',
    episode: '第10集',
    title: '板凳反击',
    desc: '全剧最沉默的角色突然爆发，一句台词都没有，却让所有观众明白什么叫“不鸣则已”。',
    image:
      'https://readdy.ai/api/search-image?query=powerful%20stylized%202d%20cartoon%20scene%20of%20a%20quiet%20sitting%20character%20rising%20with%20determined%20expression%2C%20shockwave%20comic%20effects%2C%20warm%20coral%20and%20gold%20palette%2C%20flat%20vector%20illustration%2C%20dramatic%20lighting%2C%20clean%20background&width=800&height=600&seq=scene-4&orientation=landscape',
  },
  {
    rank: '05',
    episode: '第12集',
    title: '结局独白',
    desc: '鸡哥的告别。三分钟独白没有任何配乐，只有风声，却被评为全季最催泪名场面。',
    image:
      'https://readdy.ai/api/search-image?query=poignant%20stylized%202d%20cartoon%20scene%20of%20a%20rooster%20character%20giving%20a%20quiet%20monologue%20under%20a%20big%20tree%20in%20soft%20morning%20light%2C%20warm%20peach%20and%20cream%20palette%2C%20flat%20vector%20illustration%2C%20calm%20reflective%20mood%2C%20clean%20background&width=800&height=600&seq=scene-5&orientation=landscape',
  },
];

export type Character = {
  id: string;
  name: string;
  role: string;
  desc: string;
  color: string;
  image: string;
};

export const characters: Character[] = [
  {
    id: 'ji',
    name: '鸡哥',
    role: '主角',
    desc: '热血但嘴硬，表面莽撞，背地里比谁都细心。全剧所有伏笔都藏在它的眼神里。',
    color: 'bg-primary-500',
    image:
      'https://readdy.ai/api/search-image?query=cheerful%20stylized%202d%20cartoon%20rooster%20character%20head%20portrait%20with%20a%20confident%20smile%20and%20spiky%20comb%2C%20warm%20coral%20feathers%2C%20flat%20vector%20illustration%2C%20simple%20cream%20background%2C%20playful%20mascot%20style&width=400&height=400&seq=char-ji&orientation=squarish',
  },
  {
    id: 'doubao',
    name: '豆包',
    role: '最佳损友',
    desc: '圆滚滚的小狗，嘴上说着嫌弃，身体却很诚实。雨夜道歉的名场面由它贡献。',
    color: 'bg-secondary-500',
    image:
      'https://readdy.ai/api/search-image?query=cute%20stylized%202d%20cartoon%20round%20dog%20character%20head%20portrait%20with%20big%20eyes%20and%20fluffy%20ears%2C%20warm%20golden%20fur%2C%20flat%20vector%20illustration%2C%20simple%20cream%20background%2C%20playful%20mascot%20style&width=400&height=400&seq=char-doubao&orientation=squarish',
  },
  {
    id: 'alv',
    name: '阿绿',
    role: '亦敌亦友',
    desc: '全剧最大反转担当。看似反派，其实一直在用自己的方式守护大家。',
    color: 'bg-accent-500',
    image:
      'https://readdy.ai/api/search-image?query=stylish%20stylized%202d%20cartoon%20crocodile%20or%20lizard%20character%20head%20portrait%20with%20a%20cool%20smirk%20and%20green%20scales%2C%20flat%20vector%20illustration%2C%20simple%20cream%20background%2C%20playful%20mascot%20style&width=400&height=400&seq=char-alv&orientation=squarish',
  },
  {
    id: 'dayi',
    name: '大姨',
    role: '智慧担当',
    desc: '食堂掌勺，全剧真正的“家长”。那把勺子一挥，再难的抉择都能迎刃而解。',
    color: 'bg-primary-600',
    image:
      'https://readdy.ai/api/search-image?query=warm%20stylized%202d%20cartoon%20motherly%20hen%20character%20head%20portrait%20wearing%20an%20apron%20with%20a%20kind%20smile%2C%20warm%20beige%20and%20amber%20tones%2C%20flat%20vector%20illustration%2C%20simple%20cream%20background%2C%20playful%20mascot%20style&width=400&height=400&seq=char-dayi&orientation=squarish',
  },
  {
    id: 'bandeng',
    name: '板凳',
    role: '沉默担当',
    desc: '全剧台词最少的角色，却是每次关键时刻的破局者。第10集的爆发至今被反复剪辑。',
    color: 'bg-foreground-700',
    image:
      'https://readdy.ai/api/search-image?query=calm%20stylized%202d%20cartoon%20brown%20bear%20character%20head%20portrait%20with%20a%20gentle%20quiet%20expression%2C%20warm%20brown%20fur%2C%20flat%20vector%20illustration%2C%20simple%20cream%20background%2C%20playful%20mascot%20style&width=400&height=400&seq=char-bandeng&orientation=squarish',
  },
];

export type Clip = {
  title: string;
  episode: string;
  duration: string;
  views: string;
  image: string;
};

export const highlightClips: Clip[] = [
  {
    title: '第7集 · 食堂大战 30 秒高能',
    episode: '第7集',
    duration: '00:30',
    views: '128万次',
    image:
      'https://readdy.ai/api/search-image?query=energetic%20stylized%202d%20cartoon%20video%20thumbnail%20of%20a%20canteen%20food%20fight%20with%20flying%20dishes%20and%20comic%20action%20lines%2C%20warm%20coral%20and%20gold%20palette%2C%20flat%20vector%20illustration%2C%20dynamic%20playful%20mood%2C%20clean%20background&width=800&height=450&seq=clip-1&orientation=landscape',
  },
  {
    title: '第9集 · 屋顶对峙 完整版',
    episode: '第9集',
    duration: '03:12',
    views: '96万次',
    image:
      'https://readdy.ai/api/search-image?query=dramatic%20stylized%202d%20cartoon%20video%20thumbnail%20of%20two%20rival%20characters%20standing%20on%20a%20rooftop%20at%20sunset%2C%20warm%20orange%20sky%2C%20flat%20vector%20illustration%2C%20cinematic%20tension%2C%20clean%20background&width=800&height=450&seq=clip-2&orientation=landscape',
  },
  {
    title: '第12集 · 结局独白 名场面',
    episode: '第12集',
    duration: '03:02',
    views: '215万次',
    image:
      'https://readdy.ai/api/search-image?query=emotional%20stylized%202d%20cartoon%20video%20thumbnail%20of%20a%20rooster%20character%20monologue%20under%20a%20tree%20with%20falling%20leaves%2C%20warm%20peach%20and%20cream%20palette%2C%20flat%20vector%20illustration%2C%20quiet%20bittersweet%20mood%2C%20clean%20background&width=800&height=450&seq=clip-3&orientation=landscape',
  },
];

export type Episode = {
  num: string;
  title: string;
  summary: string;
  highlights: string[];
};

export const episodes: Episode[] = [
  {
    num: '01',
    title: '初次见面，我是鸡哥',
    summary: '鸡哥来到新农场，一开口就惹了麻烦，却误打误撞认识了改变它一生的朋友们。',
    highlights: ['鸡哥登场名句', '豆包初遇'],
  },
  {
    num: '02',
    title: '阿绿的挑战书',
    summary: '阿绿正式宣战，第一场比试在食堂前上演，大姨悄悄给鸡哥留了一手。',
    highlights: ['阿绿首次亮相', '食堂比试'],
  },
  {
    num: '03',
    title: '豆包的秘密',
    summary: '豆包藏起来的鸡腿被发现了，一段关于过去的往事浮出水面。',
    highlights: ['鸡腿之谜', '雨夜伏笔'],
  },
  {
    num: '04',
    title: '大姨的规矩',
    summary: '食堂立下新规矩，鸡哥第一次见识到大姨的“铁腕”与温柔。',
    highlights: ['大姨高光', '规矩伏笔'],
  },
  {
    num: '05',
    title: '食堂大战',
    summary: '一场抢菜引发的“大战”，却是全剧最欢乐也最催泪的一集。',
    highlights: ['名场面诞生', '全员集结'],
  },
  {
    num: '06',
    title: '板凳的一天',
    summary: '沉默的板凳视角展开，原来它一直在暗中看着所有人。',
    highlights: ['板凳视角', '隐藏细节'],
  },
  {
    num: '07',
    title: '雨夜道歉',
    summary: '豆包在雨夜把鸡腿还了回来，一句对不起让弹幕集体破防。',
    highlights: ['雨夜名场面', '关系转折'],
  },
  {
    num: '08',
    title: '离队的决定',
    summary: '鸡哥第一次动了离开的念头，阿绿的态度开始松动。',
    highlights: ['离队伏笔', '阿绿转折'],
  },
  {
    num: '09',
    title: '屋顶对峙',
    summary: '阿绿摊牌，说出那句“我等的从来不是输赢”，全场气氛推向顶点。',
    highlights: ['对峙名场面', '真相浮现'],
  },
  {
    num: '10',
    title: '板凳的反击',
    summary: '沉默者爆发，一句话都没有却震撼所有人。',
    highlights: ['爆发名场面', '破局时刻'],
  },
  {
    num: '11',
    title: '最后一个约定',
    summary: '大家立下约定，鸡哥的眼神里藏着大家都没读懂的决定。',
    highlights: ['约定伏笔', '全员告别前奏'],
  },
  {
    num: '12',
    title: '结局独白',
    summary: '三分钟无配乐独白，鸡哥在风里说出了藏了一季的话，全季落幕。',
    highlights: ['结局独白', '开放式结局'],
  },
];

export type Faq = {
  q: string;
  a: string;
};

export const faqs: Faq[] = [
  {
    q: '搞鸡动画是什么？多久更新一次？',
    a: '搞鸡动画是一个专注动画剧情解析的内容站，主要围绕《搞鸡小队》第一季提供剧情解析、名场面盘点、角色关系梳理和分集解说。通常每周更新 2-3 篇新内容，重大节点会推出专题盘点。',
  },
  {
    q: '剧情解析会涉及结局剧透吗？',
    a: '会的。我们每一篇深度解析都会在标题和开头明确标注“含剧透”，方便你选择先追更还是先看解析。分集解说则不剧透后续剧情，可以放心追更时使用。',
  },
  {
    q: '可以投稿或上传自己剪辑的高能片段吗？',
    a: '当然可以。我们非常欢迎观众投稿自制剪辑，投稿一经采用会署名展示，并有机会登上“本周名场面”。投稿请联系邮箱 2143051413@qq.com。',
  },
  {
    q: '为什么有些名场面盘点需要付费？',
    a: '基础的名场面盘点、分集解说都是免费内容。付费专栏主要是独家万字长文分析、高清无压缩的剪辑原片和周边抽奖资格，用于支持网站持续产出，感谢你的理解与支持。',
  },
  {
    q: '角色关系梳理会随着新剧情更新吗？',
    a: '会的。角色关系图会随每集更新同步刷新，并在关键节点（如阿绿反转、结局）推出专题版关系梳理，方便老观众快速回顾。',
  },
];